<template>
  <Sheet>
    <template #leading>
      <Sheet.Button :icon="ChevronLeftIcon" @click="close()" />
    </template>
    <template #title>Resubscribe</template>
    <template #trailing>
      <Sheet.Button
        variant="primary"
        :icon="CheckmarkIcon"
        :disabled="loading"
        @click="handleResubscribe"
      />
    </template>

    <Sheet.Body class="pt-2">
      <ResubscribePaymentBody
        v-model:segment="segment"
        :error-message="errorMessage"
      />
    </Sheet.Body>
  </Sheet>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { Sheet, useSheet } from '@dacr/library'
import { ChevronLeftIcon, CheckmarkIcon } from '@dacr/icons'

import { useBillingStore } from '@/features/billing/store'
import ResubscribePaymentBody from './ResubscribePaymentBody.vue'
import { useResubscribe } from '../useResubscribe'

const { close } = useSheet()
const billingStore = useBillingStore()
const { loading, errorMessage, resubscribe } = useResubscribe()

const segment = ref(
  billingStore.billing?.paymentMethod?.card ? 'current' : 'new'
)

const handleResubscribe = async () => {
  if (await resubscribe(segment.value === 'new')) close()
}
</script>
